<template>
  <div id="app" class="wrapper">
    <Header @storage-updated="reloadCustomerOverview" />
     <router-view :key="viewKey" />
    <Footer />


    <b-modal :id="loadingModalId" hide-header hide-footer centered size="sm" dialog-class="loading-modal-dialog"
      no-close-on-esc no-close-on-backdrop no-fade>
      <div class="py-3 text-center">

        <b-spinner variant="light" style="width: 3rem; height: 3rem;" />
      </div>
    </b-modal>
  </div>

</template>

<script lang="ts">
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { Component } from "vue-property-decorator";
import BaseComponent from "@/components/BaseComponent";
import * as userService from "@/service/userService";
import pkg from '../package.json';

@Component({
  components: { Header, Footer }
})
export default class App extends BaseComponent {
  //Directly detecting an "Enter" key press specifically within the browser's address bar from a Vue.js application is not possible. JavaScript running within a web page operates within the browser's sandbox and does not have access to events occurring in the browser's UI elements, such as the address bar
  isBlurOnBar: boolean = false;
  viewKey: number = 0;
  //
  async mounted() {
    await userService.getUserDetail();
    ///
    try {
      ///
      const version = pkg.version;
      console.log(version);
    } catch (error) {
    }
    //
    // Detect enter key for all component;
    window.addEventListener('keydown', this.handleKeys);
    window.addEventListener('blur', this.handleBlur);
    // detect address bar change value 
    window.addEventListener('hashchange', () => {
      location.reload();
    });
  }
  //
reloadCustomerOverview() {
  console.log(this.$route.name);
  // kiểm tra route hiện tại
  if (this.$route.name === 'ManageAccount') {
    this.viewKey++;
  }
}
  ///
  handleKeys(event) {
    if (event.key === 'Enter' && this.isBlurOnBar) {
      location.reload();
    }
  }

  handleBlur(event) {
    this.isBlurOnBar = true;
  }

  beforeDestroy() {
    window.removeEventListener('hashchange', this.handleKeys);
    window.removeEventListener('keydown', this.handleKeys);
    window.removeEventListener('blur', this.handleBlur);
    this.isBlurOnBar = false;
  }

}
</script>

<style lang="scss">
#app {
  padding-top: 3rem;
}
</style>
